import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    host: {
        class: 'right context-actions',
    },
    selector: 'ndt-report-contextual-actions',
    templateUrl: 'report-contextual-actions.component.html',
    standalone: false
})
export class ReportContextalActionsComponent {
   @Input() showDownloadOptions = false;

   @Input()
   set allowPdf(allowPdf: boolean) {
      this._allowPdf = coerceBooleanProperty(allowPdf);
   }

   get allowPdf(): boolean {
      return this._allowPdf;
   }

   private _allowPdf = true;

   @Input()
   set allowHtml(allowHtml: boolean) {
      this._allowHtml = coerceBooleanProperty(allowHtml);
   }

   get allowHtml(): boolean {
      return this._allowHtml;
   }

   private _allowHtml = true;

   @Input()
   set allowExcel(allowExcel: boolean) {
      this._allowExcel = coerceBooleanProperty(allowExcel);
   }

   get allowExcel(): boolean {
      return false; //TODO: Uncomment once excel exporting is implemented https://jira.lcs.com/browse/NDT-4298
      //return this._allowExcel;
   }

   private _allowExcel = true;

   @Input()
   set allowConfigure(allowConfigure: boolean) {
      this._allowConfigure = coerceBooleanProperty(allowConfigure);
   }

   get allowConfigure(): boolean {
      return this._allowConfigure;
   }

   private _allowConfigure = true;

   @Input()
   set allowMemorize(allowMemorize: boolean) {
      this._allowMemorize = coerceBooleanProperty(allowMemorize);
   }

   get allowMemorize(): boolean {
      return this._allowMemorize;
   }

   private _allowMemorize = true;

   @Input() isLoading: boolean;

   @Output() configure = new EventEmitter<void>();

   @Output() downloadExcel = new EventEmitter<void>();

   @Output() downloadHtml = new EventEmitter<void>();

   @Output() downloadPdf = new EventEmitter<void>();

   @Output() saveParameters = new EventEmitter<void>();

   onConfigure(): void {
      this.configure.emit();
   }

   onSaveParameters(): void {
      this.saveParameters.emit();
   }

   onDownloadExcel(): void {
      this.downloadExcel.emit();
   }

   onDownloadHtml(): void {
      this.downloadHtml.emit();
   }

   onDownloadPdf(): void {
      this.downloadPdf.emit();
   }

   onPrint(): void {
      window.print();
   }
}
